<template>
  <section class="has-background-primary site-info">
    <div class="icon-container" >
      <img :src="`${$publicPath()}logo.jpg`" class="logo"/>
      <div class="has-text-white links-container">
        <router-link :to="{name: 'home'}" tag="a" class="has-text-white">Home</router-link> |
        <router-link :to="{name: 'about'}" tag="a" class="has-text-white">About us</router-link> |
        <a @click="contactModalOpen=true" class="has-text-white">Contact</a> |
        <router-link :to="{name: 'terms'}" tag="a" class="has-text-white">
          Terms & privacy
        </router-link> |
        <a :href="`${$publicPath()}SKIPPERSBOOK_USER_GUIDE.pdf`"
          target="_blank" class="has-text-white">
          User guide
        </a>
      </div>
      <div>
        <a href="https://www.facebook.com/Skippers-Book-2274369536217348/" target="_blank"><b-icon class="icon" icon="facebook" type="is-primary"/></a>
        <a href="https://twitter.com/SkipperBook" target="_blank"><b-icon class="icon" icon="twitter" type="is-primary"/></a>
        <a href="https://www.instagram.com/skippersbook/ " target="_blank"><b-icon class="icon" icon="instagram" type="is-primary"/></a>
      </div>
    </div>

    <div class="has-text-centered is-size-7 has-text-white">
      <hr style="dashed" />

      <p>&#169;2019 SkippersBook. All Rights Reserved. Designed by
        <a href="https://www.minimal.gr/ " target="_blank">
          <b class="has-text-white">Minimal</b>
        </a>
      </p>
    </div>
    <b-modal :active.sync="contactModalOpen" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          Contact form
        </header>
        <div class="modal-card-body">
          <form @submit="submitContact">
            <b-field label="Name">
              <b-input required  v-model="contactName"/>
            </b-field>
            <b-field label="Email">
              <b-input required type="email" v-model="contactEmail"/>
            </b-field>
            <b-field label="Message">
              <b-input required type="textarea" v-model="contactMessage"/>
            </b-field>
            <button class="button is-primary" type="submit">Submit</button>
          </form>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  data() {
    return {
      contactModalOpen: false,
      contactName: '',
      contactEmail: '',
      contactMessage: '',
    };
  },
  methods: {
    async submitContact(event) {
      event.preventDefault();
      try {
        await this.$http.post(
          '/contact/',
          {
            email: this.contactEmail,
            name: this.contactName,
            message: this.contactMessage,
          },
        );
        this.$toast.open({
          message: 'Message sent',
          type: 'is-success',
        });
        this.contactName = '';
        this.contactEmail = '';
        this.contactMessage = '';
        this.contactModalOpen = false;
      } catch (e) {
        this.$toast.open({
          message: 'Failed to send message',
          type: 'is-danger',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.logo {
  max-width: 30%;
}

.site-info {
  margin-top: 2rem;
  padding: 1rem;
}

.icon {
  border-radius: 100px;
  padding: 1rem;
  margin-left: 0.5rem;
  background: white;
}
.icon-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.links-container {
  align-self: flex-end;
}
</style>
